const Styles = {
    'Select': 'Select_Select--62ce7b91',
    'placeholder': 'Select_placeholder--c538f64d'
};

export default Styles;